import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slice/CounterSlice";
import itemReducer from "./slice/itemSlice";
import dataReducer from "./slice/dataSlice";
import { authReducer, formReducer } from "./slice/loginSlice";
import registerNewCaseReducer from "./slice/RegisterNewCaseSlice";
import searchCase from "./slice/searchSlice";
import caseHeaderReducer from "./slice/CaseHeaderSlice";
import caseSubjectReducer from "./slice/CaseSubjectSlice";
import advancedSearchReducer from "./slice/AdvanceSearchSlice";
import notificationReducer from "./slice/NotificationSlice";
import featureAccessReducer from "./slice/featureAccessSlice";
import caseStagesReducer from "./slice/caseStagesSlice";
import CaseDashoardSlice from "./slice/DashBoardSlice";

export const store = configureStore({
  reducer: {
    form: formReducer,
    auth: authReducer,
    counter: counterReducer,
    items: itemReducer,
    data: dataReducer,
    registerNewCase: registerNewCaseReducer,
    searchcase: searchCase,
    caseHeader: caseHeaderReducer,
    caseSubject: caseSubjectReducer,
    advancedSearch: advancedSearchReducer,
    notifications: notificationReducer,
    featureAccess: featureAccessReducer,
    caseStages: caseStagesReducer,
    DashBoardStage: CaseDashoardSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          "featureAccess.allowedFeatures",
        ],
        ignoredActions: [
          "feature_access/setAllowedFeature",
        ],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
